module.exports = __webpack_public_path__ + "img/chang-tien-wei-7.78de9f89.jpg";